interface IProps {
  title: string
  onClick: any
  active: boolean | undefined
  [key: string]: any
}

export default function CategoryListItem({
  className,
  title,
  onChange,
  active,
  ...rest
}: IProps) {
  return (
    <button
      className={`${
        className || ''
      } mr-2 mb-3 inline-block rounded-4xl border  px-6 py-1.5  ${
        active
          ? 'border-black bg-black text-white hover:bg-black'
          : 'border-gray-100 hover:bg-gray-100'
      }`}
      onChange={onChange}
      {...rest}
    >
      {title}
    </button>
  )
}
